// 预设演示模型清单：模型数据仅部署在线上服务器，不随仓库与构建分发
export interface PresetModel {
  label: string
  path: string
}

export const REMOTE_MODEL_ORIGIN = 'http://10.10.20.73'

export const PRESET_MODELS: PresetModel[] = [
  { label: 'Model 1（37MB）', path: '/model1/ply/point_cloud_20_lod/lod-meta.json' },
  { label: 'Model 2（80MB）', path: '/model2/ply/epoch_20_lod/lod-meta.json' },
  { label: 'Model 3（194MB）', path: '/model3/ply/point_cloud_10_lod/lod-meta.json' },
]

// 解析预设模型 URL：线上访问走同源相对路径，本地 dev 自动拼接部署服务器地址跨源加载
export function isLocalDevelopmentHost(hostname: string): boolean {
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
    return true
  }

  if (hostname === new URL(REMOTE_MODEL_ORIGIN).hostname) {
    return false
  }

  return (
    /^10\./.test(hostname)
    || /^192\.168\./.test(hostname)
    || /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
    || /^169\.254\./.test(hostname)
  )
}

export function resolvePresetModelUrl(path: string): string {
  if (typeof window !== 'undefined' && isLocalDevelopmentHost(window.location.hostname)) {
    return `${REMOTE_MODEL_ORIGIN}${path}`
  }

  return path
}

function normalizeModelPath(path: string): string {
  const trimmedPath = path.trim()
  try {
    const url = new URL(trimmedPath)
    return url.pathname
  } catch {
    return trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`
  }
}

export function resolvePresetModelInputPath(path: string): string | null {
  const normalizedPath = normalizeModelPath(path)

  for (const model of PRESET_MODELS) {
    const modelDirectory = model.path.replace(/\/[^/]+$/, '')
    if (
      normalizedPath === model.path
      || normalizedPath === modelDirectory
      || normalizedPath === `${modelDirectory}/`
    ) {
      return resolvePresetModelUrl(model.path)
    }
  }

  return null
}

// 默认预设模型（model1）：3DGS 示例页面打开时未通过 URL 指定模型则自动加载它
export function getDefaultPresetModelUrl(): string {
  return resolvePresetModelUrl(PRESET_MODELS[0].path)
}
